import React, { PureComponent, Component } from 'react';
import CheckDefecto from '../../../../Common/Components/CheckDefecto'

class Semanal extends Component {
    constructor(props) {
        super(props)
        this.selectRadio = this.selectRadio.bind(this);
    }


    selectRadio(value) {
        this.props.selectRadio("Periodicidad", value)

    }

    render() {

        const { data, setCheck } = this.props;

        return (
            <div className="row top-separator-xs">
                <div className="row row-radio">
                    <div style={{marginLeft:"35px"}} className="col-xs-12">
                        <div className="container-radio radio-margin">
                            <input id={"rbSoloSemanal" + 1}
                                type="radio"
                                name="rbSoloSemanal"
                                value={true}
                                data-value={"Semanal"}
                                checked={data.proceso.Periodicidad == "Semanal"}
                                onChange={(event) => this.selectRadio(event.target.dataset.value)} />
                            />
                            <label style={{marginLeft:"10px"}}
                                className="lbl-radio label-secondary"
                                htmlFor={"rbSoloSemanal" + 1}>
                                {"Sólo los días"}
                            </label>
                        </div>
                    </div>
                </div>

                <CheckDefecto
                       nombre={"Lunes"}
                       referencia={"Lunes"}
                       id={"Lunes"}
                       activo={data.proceso.Periodicidad == "Semanal"}
                       check={data.calendario.DiaSemanaLunes && data.proceso.Periodicidad == "Semanal"}
                       selectCheckBox={(event) => setCheck("DiaSemanaLunes",event.target.checked)}      
                       style={{ marginLeft:'55px', float:'left'}}
                />
                <CheckDefecto
                       nombre={"Martes"}
                       referencia={"Martes"}
                       id={"Martes"}
                       activo={data.proceso.Periodicidad == "Semanal"}
                       check={data.calendario.DiaSemanaMartes && data.proceso.Periodicidad == "Semanal"}
                       selectCheckBox={(event) => setCheck("DiaSemanaMartes",event.target.checked)}  
                       style={{ marginLeft: "10px", float: "left"}}    
                />
                <CheckDefecto
                       nombre={"Miércoles"}
                       referencia={"Miércoles"}
                       id={"Miércoles"}
                       activo={data.proceso.Periodicidad == "Semanal"}
                       check={data.calendario.DiaSemanaMiercoles && data.proceso.Periodicidad == "Semanal"}
                       selectCheckBox={(event) => setCheck("DiaSemanaMiercoles",event.target.checked)}      
                       style={{ marginLeft: "6px", marginRight : "7px", float : "left"}}
                />
                <CheckDefecto
                       nombre={"Jueves"}
                       referencia={"Jueves"}
                       id={"Jueves"}
                       activo={data.proceso.Periodicidad == "Semanal"}
                       check={data.calendario.DiaSemanaJueves && data.proceso.Periodicidad == "Semanal"}
                       selectCheckBox={(event) => setCheck("DiaSemanaJueves",event.target.checked)}    
                       style={{ marginLeft : "6px"}}  
                />
                <CheckDefecto
                       nombre={"Viernes"}
                       referencia={"Viernes"}
                       id={"Viernes"}
                       activo={data.proceso.Periodicidad == "Semanal"}
                       check={data.calendario.DiaSemanaViernes && data.proceso.Periodicidad == "Semanal"}
                       selectCheckBox={(event) => setCheck("DiaSemanaViernes",event.target.checked)}      
                       style={{marginLeft: "119px", float: "left"}}
                />
                <CheckDefecto
                       nombre={"Sábado"}
                       referencia={"Sábado"}
                       id={"Sábado"}
                       activo={data.proceso.Periodicidad == "Semanal"}
                       check={data.calendario.DiaSemanaSabado && data.proceso.Periodicidad == "Semanal"}
                       selectCheckBox={(event) => setCheck("DiaSemanaSabado", event.target.checked)}  
                       style={{ marginLeft : "6px", marginRight : "18px", float : "left"}}    
                />
                <CheckDefecto
                       nombre={"Domingo"}
                       referencia={"Domingo"}
                       id={"Domingo"}
                       activo={data.proceso.Periodicidad == "Semanal"}
                       check={data.calendario.DiaSemanaDomingo && data.proceso.Periodicidad == "Semanal"}
                       selectCheckBox={(event) => setCheck("DiaSemanaDomingo", event.target.checked)}      
                       style={{ marginLeft: "10px"}}
                />
                <CheckDefecto
                      nombre={"Solo días hábiles"}
                      referencia={"DiasHabiles" + 2}
                      id={"DiasHabiles" + 2}
                      activo={data.proceso.Periodicidad == "Semanal" && !data.calendario.DiaSemanaSabado && !data.calendario.DiaSemanaDomingo }
                      check={data.calendario.DiaHabil && data.proceso.Periodicidad == "Semanal" && !data.calendario.DiaSemanaSabado && !data.calendario.DiaSemanaDomingo}
                      selectCheckBox={(event) => setCheck("DiaHabil", event.target.checked)}      
                      style={{ marginLeft : "56px"}}
                />

                {!data.ERROR_PROCESS["seleccionoDiaSemana"] && data.proceso.Periodicidad == "Semanal" && 
                            <label className="error">{"Debe seleccionar al menos un día de la semana."}</label>}

            </div>
        )
    }
};

export default Semanal;